export enum SupportSubRoutes {
  DASHBOARD = '/dashboard',

  TICKETS_LIST = '/tickets',
  TICKET_CONVERSATION = '/tickets/:ticketId',

  CUSTOMER_TICKET_LIST = '/customer-tickets',
  CUSTOMER_TICKET_CONVERSATION = '/customer-tickets/:ticketId',

  JOBS_TICKET_LIST = '/jobs-tickets',
  JOBS_TICKET_CONVERSATION = '/jobs-tickets/:ticketId',

  PARTNER_TICKET_LIST = '/partner-tickets',
  PARTNER_TICKET_CONVERSATION = '/partner-tickets/:ticketId',
}
